import React from 'react'

interface ExpandProps extends React.SVGProps<SVGSVGElement> {
    color?: string
}

export const Expand = ({ width = 20, height = 20, color = '#FFFFFF', ...rest }: ExpandProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9644 3.25037C11.6882 3.25037 11.4644 3.47422 11.4644 3.75037C11.4644 4.02651 11.6882 4.25037 11.9644 4.25037H15.0429L10.8965 8.39647C10.7013 8.59173 10.7013 8.90831 10.8965 9.10358C11.0918 9.29885 11.4084 9.29886 11.6036 9.1036L15.7501 4.95742V8.0358C15.7501 8.31194 15.9739 8.5358 16.2501 8.5358C16.5262 8.5358 16.7501 8.31194 16.7501 8.0358V3.75037C16.7501 3.47422 16.5262 3.25037 16.2501 3.25037H11.9644ZM9.10365 10.8965C8.90839 10.7012 8.59181 10.7012 8.39654 10.8965L4.24976 15.043V11.9643C4.24976 11.6882 4.0259 11.4643 3.74976 11.4643C3.47361 11.4643 3.24976 11.6882 3.24976 11.9643V16.25C3.24976 16.5262 3.47361 16.75 3.74976 16.75H8.03575C8.31189 16.75 8.53575 16.5262 8.53575 16.25C8.53575 15.9739 8.31189 15.75 8.03575 15.75H4.95692L9.10363 11.6036C9.29889 11.4083 9.2989 11.0918 9.10365 10.8965Z"
                fill={color}
            />
        </svg>
    )
}
